import { ITEM_MOTION } from '../config.js';
import { getItemSafeBounds, resolveItemLayoutKey } from './itemSafeBounds.js';

/**
 * @param {number} random
 * @param {typeof ITEM_MOTION} [motion]
 */
export function createItemMotion(random = Math.random, motion = ITEM_MOTION) {
    const angle = random() * Math.PI * 2;
    const jitter = 1 + (random() * 2 - 1) * motion.speedJitter;
    const speed = motion.speedPercentPerSecond * jitter;
    const rotate = (random() * 2 - 1) * motion.tiltDegrees;

    return {
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed,
        rotate: Math.round(rotate * 10) / 10,
    };
}

/**
 * @param {Array<{ x: number, y: number, vx: number, vy: number }>} items
 * @param {number} tickMs
 * @param {typeof ITEM_MOTION} [motion]
 * @param {number} [speedScale]
 * @param {{ width: number, height: number }} [boardSize]
 */
export function updateItemsMotion(
    items,
    tickMs,
    motion = ITEM_MOTION,
    speedScale = 1,
    boardSize = { width: 400, height: 320 },
) {
    if (!items.length) return items;

    const dt = (tickMs / 1000) * Math.max(0, speedScale);

    return items.map((item) => {
        if (item.popping) return item;

        const { minX, maxX, minY, maxY } = getItemSafeBounds(boardSize, resolveItemLayoutKey(item));

        let { x, y, vx, vy } = item;

        x += vx * dt;
        y += vy * dt;

        if (x < minX) {
            x = minX;
            vx = Math.abs(vx);
        } else if (x > maxX) {
            x = maxX;
            vx = -Math.abs(vx);
        }

        if (y < minY) {
            y = minY;
            vy = Math.abs(vy);
        } else if (y > maxY) {
            y = maxY;
            vy = -Math.abs(vy);
        }

        return { ...item, x, y, vx, vy };
    });
}
